import * as yup from 'yup';

import { updateStatusTypes } from "../../hooks/api/useTransactions"

let _allowStatusTypes = Object.keys(updateStatusTypes).map(i => updateStatusTypes[i])
let allowStatusTypes = _allowStatusTypes.filter(i => i !== updateStatusTypes.pending)

export const validationToUserIdSchema = yup.object({
    toUserId: yup
        .string()
        .required("Required"),
    toUsername: yup
        .string()
        .required("Required"),
    toWalletUserId: yup
        .string()
        .required("Required"),
})

export const validationStatusTypeSchema = yup.object({
    statusType: yup
        .string()
        .oneOf(allowStatusTypes)
        .required("Required"),
    transactionDate: yup
        .date("Invalid")
        .required("Required")
        .required("Required"),
})

export const validationSchema = yup.object({
    actionType: yup
        .string()
        .required("Required"),
    fromUserId: yup
        .string()
        .required("Required"),
    fromUsername: yup
        .string()
        .required("Required"),
    fromWalletUserId: yup
        .string()
        .required("Required"),
    fromWalletCurrency: yup
        .string()
        .required("Required"),

    transactionAmount: yup
        .number()
        .typeError("Only Number")
        .required("Required"),
    description: yup
        .string()
        .required("Required"),
})

export const initialToUserIdValues = {
    toUserId: "",
    toUsername: "",
    toWalletUserId: "",
}

export const initialStatusTypeValues = {
    statusType: ""
}

export const initialValues = {
    actionType: "",
    description: "",

    fromUserId: "",
    fromUsername: "",
    fromWalletUserId: "",
    fromWalletCurrency: "",
    
    walletType: "",
    transactionAmount: "",
    referenceNo: "",
    remark: "",

    transactionDate: "",
    internalReferenceNo: "",
    internalRemark: "",
}